module.exports = __webpack_public_path__ + "img/label.15231532.svg";